import { useEffect } from "react";
import NavBar from "@/components/woost/NavBar";
import HeroSection from "@/components/woost/HeroSection";
import DifferenceSection from "@/components/woost/DifferenceSection";
import ServicesSection from "@/components/woost/ServicesSection";
import ContentConvertsSection from "@/components/woost/ContentConvertsSection";
import CreatorGallery from "@/components/woost/CreatorGallery";
import TestimonialsSection from "@/components/woost/TestimonialsSection";
import CaseStudiesSection from "@/components/woost/CaseStudiesSection";
import BlogSection from "@/components/woost/BlogSection";
import ContactSection from "@/components/woost/ContactSection";
import Footer from "@/components/woost/Footer";
import ScrollToTop from "@/components/woost/ScrollToTop";
import { AnimatePresence } from "framer-motion";
import InfiniteScrollVideo from "@/components/woost/InfiniteScrollVideo";

const Index = () => {
  useEffect(() => {
    // Smooth scrolling for anchor links
    const handleScroll = (e: Event): void => {
      e.preventDefault();
      const target = e.target as HTMLAnchorElement;
      const targetId = target.getAttribute("href")?.substring(1);
      if (targetId) {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    };

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", handleScroll);
    });

    // Cleanup
    return () => {
      document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.removeEventListener("click", handleScroll);
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <AnimatePresence>
        <div className="relative">
          <NavBar />
          <HeroSection />
          <DifferenceSection />
          {/* <div>
            <video
              src="/video/exporrt.mp4"
              loop
              muted
              autoPlay
              playsInline
              className="w-full h-[300px] object-cover"
            ></video>
          </div> */}
          <InfiniteScrollVideo />
          <ServicesSection />
          <ContentConvertsSection />
          <CreatorGallery />
          <TestimonialsSection />
          <CaseStudiesSection />
          {/* <BlogSection /> */}
          <ContactSection creatorCount={25000} />
          <Footer />
          <ScrollToTop />
        </div>
      </AnimatePresence>
    </div>
  );
};

export default Index;
